import { render, staticRenderFns } from "./card-info-horizontal-slider.vue?vue&type=template&id=a660467e&scoped=true&"
import script from "./card-info-horizontal-slider.vue?vue&type=script&lang=js&"
export * from "./card-info-horizontal-slider.vue?vue&type=script&lang=js&"
import style0 from "./card-info-horizontal-slider.vue?vue&type=style&index=0&id=a660467e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a660467e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow})
